import MovementsRoutes from "./movements";

export default [...MovementsRoutes];
